/**
 * Route for `igaming-multi-currency-invoice-generation`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingMultiCurrencyInvoiceGenerationPage } from "../features/igaming-multi-currency-invoice-generation/IgamingMultiCurrencyInvoiceGenerationPage";

export const igamingMultiCurrencyInvoiceGenerationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-multi-currency-invoice-generation",
	component: IgamingMultiCurrencyInvoiceGenerationPage,
});

export default igamingMultiCurrencyInvoiceGenerationRoute;
